

















import { Component, Prop } from 'vue-property-decorator';
import AmazonProductDetailsModel from '../models/ProductDetails';
import { ShopDetailsModel } from '@/models/ShopDetails';
import ProductDetails from './amazon/ProductDetails.vue';
import ShopProductDetails from './local-shops/ShopProductDetails.vue';
import IdealoShopList from './idealo/IdealoShopList.vue';

import CanBeSizedMixin from '../mixins/CanBeSizedMixin.vue';
import { Position, WidgetType } from '@/models/Enums';
import CameraDetails from '@/components/Camera/CameraDetails.vue';
import { IdealoShopModel } from '@/models/Idealo';

@Component({
  components: {
    ProductDetails,
    ShopProductDetails,
    IdealoShopList,
    CameraDetails,
  },
})
export default class DetailsWrap extends CanBeSizedMixin {
  @Prop() private offer!: AmazonProductDetailsModel | ShopDetailsModel | IdealoShopModel[];
  @Prop() private type!: WidgetType;
  @Prop() private position!: Position;

  public get isAmazon() {
    return this.type === WidgetType.Amazon;
  }

  public get isLocalShop() {
    return this.type === WidgetType.LocalShop;
  }

  public get isIdealo() {
    return this.type === WidgetType.Idealo;
  }

  public get isCamera() {
    return this.type === WidgetType.Cameras;
  }
}
